module.exports = __webpack_public_path__ + "media/images/1200/REM_sleep_night_stars-2d0019f225883cfea74956c07c0af475.jpg";